import React, { useState, useEffect } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import CentrikaIcon from "../../assets/img/logo.png";
import OperatorLogo from "../../assets/img/bus.png";
import SafariLogo from "../../assets/img/logo.svg";

import {
  Button,
  Drawer,
  ListItemText,
  IconButton,
  ListItemIcon,
  ListItem,
  Divider,
  List,
  Grid,
  Paper,
  Typography,
  Toolbar,
  AppBar,
  Container,
  Box,
  Hidden,
  Menu,
  MenuItem,
  Avatar,
  useMediaQuery,
  Badge,
  ButtonBase,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

import {
  Menu as MenuIcon,
  Home,
  Equalizer,
  Settings,
  ExitToApp,
  ArrowDropDown,
  HelpRounded,
  Notifications,
  Group,
  SupervisedUserCircle,
  Store,
  Security,
  AllInclusive,
  Gavel,
  Money,
  Schedule,
  Subway,
  AirportShuttle,
  CreditCard,
  Block,
  Mail,
  Place,
  DepartureBoard,
  Assignment,
  Category,
  Assessment,
  ExpandLess,
  ExpandMore,
  ArrowRight,
  Timeline,
  MoneyOff,
  LocalAtm,
  WbIncandescentOutlined,
  DevicesOther,
  PeopleOutline,
  DataUsage,
  People,
  SwapHoriz,
  SyncAlt,
  ContactSupport,
  GroupAdd,
  Portrait
} from "@material-ui/icons";

import { makeStyles, useTheme } from "@material-ui/styles";
import { Speed } from "@material-ui/icons";

import { withLocalize, Translate } from "react-localize-redux";

import { Link, Switch, Route, useHistory } from "react-router-dom";


import {Permissions} from "./../../utils/web_config_2";


import Dashboard from "./dashboard.jsx";
import Outlet from "./outletes.jsx";
import Offense from "./offenses.jsx";
import SSchedule from "./schedule.jsx";
import Stop from "./stop.jsx";
import RRoute from "./route.jsx";
import Vehicle from "./vehicle";
import Driver from "./driver.jsx";
import Users from "./users";
import Members from "./users_members";
import UserRoute  from "./user_route";
import PosAgent  from "./user_route2";
import Fines from "./fines";
import CategoryOffense from "./category_offense";
import Commissions from "./commissions";
import Deductions from "./deductions";
import SSettings from "./settings";


import RouteSchedule from "./route_schedule";
import Devices from "./devices";

import InitiateSettlemnt from "./initiate_settlement";
import OperatorTransaction from "./report_transaction.jsx";

import ReportPOS from "./report_pos";
import ReportUser from "./report_user";
import ReportBus from "./report_bus";
import ReportBranch from "./report_branch";
import ReportTraffic from "./report_traffic";
import ReportSettlement from "./report_settlement";
import ReportFine from "./daily_fine_report";
import ReportBusinessOverview from "./report_business_overview";
import ReportManifesto from "./report_manifesto";
import BusStopReport from "./report_bus_stop";
import AuditTrails from "./report_audit_trails";
import TripNumber from "./report_tripnumber";
import TicketSearch from "./report_search_ticket";
import UserManager from "./agent_manager.jsx";
import Agent from "./agent.jsx";
import AgentManagerDetails from "./agent_manager_details.jsx";
import ComparativeReport from "./report_comparative.jsx";
import BusLocationReport from "./report_bus_location.jsx";
import ReportUserV1 from "./report_user_v1.jsx";

import ReportRura from "./report_rura.jsx";

import DriverReport from "./report_driver.jsx";

// old report 

import ReportUserOld from './report_user_old.jsx';
import ReportBranchOld from'./report_branch_old.jsx';


/// agent manager

import AgentHome from "./agent_manager/home.jsx";
import AgentManagerAgents from "./agent_manager/manager_agents.jsx";
import AgentDetails from "./agent_manager/agent_details.jsx";
import AgentTransaction from "./agent_manager/manager_transactions.jsx";
import AgentOperatorDetails from "./agent_details.jsx";
import SettingsManager from "./settings_manager.jsx";



import TestPDF from "./test_pdf";

import axios from 'axios';

import {AdminService} from "./../../utils/web_config_2";

import UserInfo from "./login_info";

import { useSnackbar } from 'notistack';
import { stringify } from "uuid";
import RoutePerformanceReport from "./performance-report/route-performance-report";
import BusPerformanceReport from "./performance-report/bus-performance-report";
import GeneralPerformanceReport from "./performance-report/general-performance-report";
import PosAgentReport from "../../pages/reports/pos-agents";
import InvalidAndVoidedTickets from "./other-reports/InvalidAndVoidedTickets";
import FraudulentCardTaps from "./other-reports/FraudulentCardTaps";

import AccountDetails from "./account_details";
import LoyalCustomerReport from './loal-customer-report';

const routes = [
	{
		path: '/operator',
		exact: true,
		main: () => <Dashboard />,
	},
	{
		path: '/operator/loyal-customer-report',
		exact: true,
		main: () => <LoyalCustomerReport />,
	},
	{
		path: '/operator/serviceFeeReport',
		exact: true,
		main: () => <AccountDetails />,
	},
	{
		path: '/operator/home',
		exact: true,
		main: () => <Dashboard />,
	},
	{
		path: '/operator/branch',
		exact: true,
		main: () => <Outlet />,
	},
	{
		path: '/operator/categoryoffense',
		exact: true,
		main: () => <CategoryOffense />,
	},
	{
		path: '/operator/offense',
		exact: true,
		main: () => <Offense />,
	},
	{
		path: '/operator/fine',
		exact: true,
		main: () => <Fines />,
	},
	{
		path: '/operator/commissions',
		exact: true,
		main: () => <Commissions />,
	},
	{
		path: '/operator/stop',
		exact: true,
		main: () => <Stop />,
	},
	{
		path: '/operator/route',
		exact: true,
		main: () => <RRoute />,
	},
	{
		path: '/operator/schedule',
		exact: true,
		main: () => <RouteSchedule />,
	},
	{
		path: '/operator/schedule/:id',
		exact: true,
		main: () => <SSchedule />,
	},
	{
		path: '/operator/vehicle',
		exact: true,
		main: () => <Vehicle />,
	},
	{
		path: '/operator/driver',
		exact: true,
		main: () => <Driver />,
	},
	{
		path: '/operator/userRoute',
		exact: true,
		main: () => <UserRoute />,
	},
	{
		path: '/operator/posAgent',
		exact: true,
		main: () => <PosAgent />,
	},
	{
		path: '/operator/tickets',
		exact: true,
		main: () => <Typography></Typography>,
	},
	{
		path: '/operator/settings',
		exact: true,
		main: () => <SSettings />,
	},
	{
		path: '/operator/members',
		exact: true,
		main: () => <Members />,
	},
	{
		path: '/operator/users',
		exact: true,
		main: () => <Users />,
	},

	{
		path: '/operator/deductions',
		exact: true,
		main: () => <Deductions />,
	},
	{
		path: '/operator/settlementreport',
		exact: true,
		main: () => <ReportSettlement />,
	},
	{
		path: '/operator/trafficreport',
		exact: true,
		main: () => <ReportTraffic />,
	},
	{
		path: '/operator/dailyposreport',
		exact: true,
		main: () => <ReportPOS />,
	},
	{
		path: '/operator/reports/members',
		exact: true,
		main: () => <PosAgentReport />,
	},
	{
		path: '/operator/route-performance-report',
		exact: true,
		main: () => <RoutePerformanceReport />,
	},
	{
		path: '/operator/bus-performance-report',
		exact: true,
		main: () => <BusPerformanceReport />,
	},
	{
		path: '/operator/general-performance-report',
		exact: true,
		main: () => <GeneralPerformanceReport />,
	},
	{
		path: '/operator/userreport',
		exact: true,
		main: () => <ReportUser />,
	},
	{
		path: '/operator/userreportv1',
		exact: true,
		main: () => <ReportUserV1 />,
	},
	{
		path: '/operator/busreport',
		exact: true,
		main: () => <ReportBus />,
	},
	{
		path: '/operator/branchreport',
		exact: true,
		main: () => <ReportBranch />,
	},
	{
		path: '/operator/finesreport',
		exact: true,
		main: () => <ReportFine />,
	},
	{
		path: '/operator/businessoverviewreport',
		exact: true,
		main: () => <ReportBusinessOverview />,
	},
	{
		path: '/operator/devices',
		exact: true,
		main: () => <Devices />,
	},
	{
		path: '/operator/manifestoreport',
		exact: true,
		main: () => <ReportManifesto />,
	},
	{
		path: '/operator/initiatesettlement',
		exact: true,
		main: () => <InitiateSettlemnt />,
	},
	{
		path: '/operator/busstopreport',
		exact: true,
		main: () => <BusStopReport />,
	},
	{
		path: '/operator/reportrura',
		exact: true,
		main: () => <ReportRura />,
	},
	{
		path: '/operator/audittrails',
		exact: true,
		main: () => <AuditTrails />,
	},
	{
		path: '/operator/tripnumber',
		exact: true,
		main: () => <TripNumber />,
	},
	{
		path: '/operator/querydatabase',
		exact: true,
		main: () => <TripNumber />,
	},
	{
		path: '/operator/searchticket',
		exact: true,
		main: () => <TicketSearch />,
	},
	{
		path: '/operator/agentmanager',
		exact: true,
		main: () => <UserManager />,
	},
	{
		path: '/operator/agent',
		exact: true,
		main: () => <Agent />,
	},
	{
		path: '/operator/agentdetails',
		exact: true,
		main: () => <AgentOperatorDetails />,
	},
	{
		path: '/operator/agentmanegerdetails',
		exact: true,
		main: () => <AgentManagerDetails />,
	},
	{
		path: '/operator/transaction',
		exact: true,
		main: () => <OperatorTransaction />,
	},
	{
		path: '/operator/agentmanager/home',
		exact: true,
		main: () => <AgentHome />,
	},
	{
		path: '/operator/agentmanager/agent',
		exact: true,
		main: () => <AgentManagerAgents />,
	},
	{
		path: '/operator/agentmanager/agentdetails',
		exact: true,
		main: () => <AgentDetails />,
	},
	{
		path: '/operator/agentmanager/transaction',
		exact: true,
		main: () => <AgentTransaction />,
	},
	{
		path: '/operator/agentmanager/settings',
		exact: true,
		main: () => <SettingsManager />,
	},
	{
		path: '/operator/comparativereport',
		exact: true,
		main: () => <ComparativeReport />,
	},
	{
		path: '/operator/buslocation',
		exact: true,
		main: () => <BusLocationReport />,
	},
	{
		path: '/operator/userreport-old',
		exact: true,
		main: () => <ReportUserOld />,
	},
	{
		path: '/operator/branchreport-old',
		exact: true,
		main: () => <ReportBranchOld />,
	},
	{
		path: '/operator/driverreport',
		exact: true,
		main: () => <DriverReport />,
	},
	{
		path: '/operator/invalid-and-voided-tickets',
		exact: true,
		main: () => <InvalidAndVoidedTickets />,
	},
	{
		path: '/operator/fraudulent-card-taps',
		exact: true,
		main: () => <FraudulentCardTaps />,
	},
	{
		main: () => (
			<Box ml={30} p={7} border={1} borderRadius='borderRadius'>
				<Typography>Requested url is not found</Typography>
			</Box>
		),
	},
];

const getMenus=()=>{

const menus = [
	{
		name: <Translate id='operator_menu.home' />,
		icon: <Home />,
		path: '/operator/home',
		permissions: 'CAN_VIEW_BUSINESS_OVERVIEW',
	},

	// { name: "Home", icon: <Home />, path: "/operator/agentmanager/home",permissions:"INITIAL" },
	// { name: "Agent", icon: <People />, path: "/operator/agentmanager/agent",permissions:"INITIAL" },
	// { name: "Transactions", icon: <SyncAlt />, path: "/operator/agentmanager/transaction",permissions:"INITIAL" },

	// { name: "Home", icon: <Home />, path: "/operator/agentmanager/home",permissions:"CAN_VIEW_AGENT_MANAGER_HOME"},
	// { name: "Agent", icon: <People />, path: "/operator/agentmanager/agent",permissions:"CAN_VIEW_AGENT_MANAGER_AGENTS" },
	// { name: "Transactions", icon: <SyncAlt />, path: "/operator/agentmanager/transaction",permissions:"CAN_VIEW_AGENT_MANAGER_TRANSACTIONS" },

	{
		name: 'Business Overview',
		icon: <WbIncandescentOutlined />,
		path: '/operator/businessoverviewreport',
		permissions: 'CAN_VIEW_BUSINESS_OVERVIEW',
	},
	{
		name: <Translate id='operator_menu.branch_outlet' />,
		icon: <AllInclusive />,
		path: '/operator/branch',
		permissions: 'CAN_VIEW_BRANCH',
	},
	{
		name: <Translate id='operator_menu.categoryoffense' />,
		icon: <Category />,
		path: '/operator/categoryoffense',
		permissions: 'CAN_VIEW_OFFENSE_CATEGORY',
	},
	{
		name: <Translate id='operator_menu.offense' />,
		icon: <Gavel />,
		path: '/operator/offense',
		permissions: 'CAN_VIEW_OFFENSE',
	},
	// { name: <Translate id="operator_menu.commissions"/>, icon: <Money />, path: "/operator/commissions",permissions:"CAN_VIEW_COMMISSIONS" },
	// { name: <Translate id="operator_menu.deductions"/>, icon: <MoneyOff />, path: "/operator/deductions",permissions:"CAN_VIEW_DEDUCTIONS"},
	{
		name: <Translate id='operator_menu.stop' />,
		icon: <Place />,
		path: '/operator/stop',
		permissions: 'CAN_VIEW_STOPS_LIST',
	},
	{
		name: <Translate id='operator_menu.route' />,
		icon: <Subway />,
		path: '/operator/route',
		permissions: 'CAN_VIEW_ROUTE',
	},
	{
		name: <Translate id='operator_menu.schedules' />,
		icon: <Schedule />,
		path: '/operator/schedule',
		permissions: 'CAN_LIST_SCHEDULE',
	},
	{
		name: <Translate id='operator_menu.vehicle' />,
		icon: <AirportShuttle />,
		path: '/operator/vehicle',
		permissions: 'CAN_LIST_VEHICLE',
	},
	{
		name: <Translate id='operator_menu.driver' />,
		icon: <SupervisedUserCircle />,
		path: '/operator/driver',
		permissions: 'CAN_LIST_DRIVER',
	},
	{
		name: 'Devices',
		icon: <DevicesOther />,
		path: '/operator/devices',
		permissions: 'CAN_LIST_DEVICE',
	},
	{
		name: <Translate id='operator_menu.user_route' />,
		icon: <DepartureBoard />,
		path: '/operator/userRoute',
		permissions: 'CAN_VIEW_POS_USER',
	},
	{
		name: 'POS Agents',
		icon: <GroupAdd />,
		path: '/operator/posAgent',
		permissions: 'CAN_VIEW_POS_USER',
	},
	new UserInfo().ORG_TYPE == 'COOPERATIVE'
		? {
				name: 'Members',
				icon: <Portrait />,
				path: '/operator/members',
				permissions: 'CAN_VIEW_POS_USER',
		  }
		: {},
	{
		name: 'Pos Agents Report v2',
		path: '/operator/reports/members',
		icon: <People />,
		permissions: 'CAN_VIEW_POS_USER',
	},
	{
		name: 'Agents',
		icon: <People />,
		path: '/operator/agency',
		submenu: [
			{
				name: 'Agent Manager',
				path: '/operator/agentmanager',
				permissions: 'CAN_VIEW_AGENT_MANAGERS',
			},
			{
				name: 'Agent',
				path: '/operator/agent',
				permissions: 'CAN_VIEW_AGENTS',
			},
		],
		permissions: 'CAN_VIEW_AGENTS',
	},
	{
		name: 'Finance',
		icon: <SwapHoriz />,
		path: '/operator/finance',
		submenu: [
			{
				name: 'Transactions History',
				path: '/operator/transaction',
				permissions: 'CAN_VIEW_OPERATOR_TRANSACTIONS',
			},
		],
		permissions: 'CAN_VIEW_OPERATOR_TRANSACTIONS',
	},
	{
		name: 'Reports',
		icon: <Timeline />,
		path: '/operator/reports',
		submenu: [
			{
				name: 'Loyal Customer Report',
				path: '/operator/loyal-customer-report',
			},
			{
				name: 'Service Fee Report',
				path: '/operator/serviceFeeReport',
				permissions: 'CAN_VIEW_POS_USER',
			},
			{ name: 'Daily Fine Tickets', path: '/operator/dailyfinetickets' },
			// { name: "Daily Bus Tickets",  path: "/operator/dailybustickets" },
			// { name: "Bus Tickets",path: "/operator/bustickets" },
			{ name: 'Fine Tickets', path: '/operator/finesreport' },
			{
				name: 'Daily Traffic Report',
				path: '/operator/trafficreport',
				permissions: 'CAN_VIEW_DAILY_SALES_REPORT',
			},
			// { name: "Daily settlement",  path: "/operator/settlementreport" },
			{
				name: 'Sales Report',
				path: '/operator/dailyposreport',
				permissions: 'CAN_VIEW_SALES_PER_CHANNEL_REPORT',
			},
			{
				name: 'User Report',
				path: '/operator/userreport',
				permissions: 'CAN_VIEW_POS_USER_SALES_REPORT',
			},
			{
				name: 'User Report V1',
				path: '/operator/userreportv1',
				permissions: 'CAN_VIEW_POS_USER_SALES_REPORT',
			},
			{
				name: 'Bus Report',
				path: '/operator/busreport',
				permissions: 'CAN_VIEW_VEHICLE_SALES_REPORT',
			},
			{
				name: 'Bus Stop Report',
				path: '/operator/busstopreport',
				permissions: 'CAN_VIEW_VEHICLE_SALES_REPORT',
			},
			{
				name: 'Branch Report',
				path: '/operator/branchreport',
				permissions: 'CAN_VIEW_BRANCH_SALES_REPORT',
			},
			{
				name: 'Manifesto Report',
				path: '/operator/manifestoreport',
				permissions: 'CAN_VIEW_POS_USER',
			},
			{ name: 'Route Performance', path: '/operator/route-performance-report' },
			{ name: 'Bus Performance', path: '/operator/bus-performance-report' },
			{
				name: 'Genral Performance Report',
				path: '/operator/general-performance-report',
			},
			{
				name: 'Comparative Report',
				path: '/operator/comparativereport',
				permissions: 'CAN_VIEW_POS_USER',
			},

			{
				name: 'Bus live location',
				path: '/operator/buslocation',
				permissions: 'CAN_VIEW_POS_USER',
			},

			{
				name: 'Driver Report',
				path: '/operator/driverreport',
				permissions: 'CAN_VIEW_POS_USER',
			},

			{
				name: 'RURA Report',
				path: '/operator/reportrura',
				permissions: 'CAN_VIEW_POS_USER',
			},
			{ name: 'Audit Trails', path: '/operator/audittrails' },

			{
				name: 'Invalid/Voided Tickets',
				path: '/operator/invalid-and-voided-tickets',
			},

			// { name: 'Fraudulent Card Taps', path: '/operator/fraudulent-card-taps' },
		],
		permissions: 'CAN_DOWNLOAD_DAILY_SALES_REPORT',
	},
	// {
	//   name: "Old Reports",
	//   icon: <Timeline />,
	//   path: "",
	//   submenu: [
	//     { name: "User Report (Agent)",  path: "/operator/userreport-old",permissions:"CAN_VIEW_POS_USER_SALES_REPORT" },
	//     { name: "Branch Report ",  path: "/operator/branchreport-old",permissions:"CAN_VIEW_POS_USER_SALES_REPORT" },
	//   ],permissions:"CAN_DOWNLOAD_DAILY_SALES_REPORT"
	// },
	{
		name: 'Query Database',
		icon: <DataUsage />,
		path: '/operator/querydatabase',
		submenu: [
			{
				name: 'Trip Number Report',
				path: '/operator/tripnumber',
				permissions: '',
			},
			{
				name: 'Search Ticket',
				path: '/operator/searchticket',
				permissions: '',
			},
			{
				name: 'User Report (Agent)',
				path: '/operator/userreport-old',
				permissions: 'CAN_VIEW_POS_USER_SALES_REPORT',
			},
			{
				name: 'Branch Report ',
				path: '/operator/branchreport-old',
				permissions: 'CAN_VIEW_POS_USER_SALES_REPORT',
			},
		],
		permissions: 'CAN_DOWNLOAD_DAILY_SALES_REPORT',
	},
	{
		name: 'Settlement Report',
		icon: <LocalAtm />,
		path: '/operator/reports',
		submenu: [
			{ name: 'Settlement batches report', path: '/operator/settlementreport' },
			// { name: "Initiate settlement process",  path: "/operator/initiatesettlement" },
			// { name: "Settlement Transaction Batches",  path: "/operator/settlementbatchreport" }
		],
		permissions: 'CAN_VIEW_SETTLEMENT_REPORT',
	},
];
return menus;
}

const menus2 = [
  { name: <Translate id="operator_menu.user"/>, icon: <PeopleOutline /> ,path: "/operator/users",permissions:"CAN_VIEW_ORG_USER"},
  { name: <Translate id="operator_menu.setting"/>, icon: <Settings />,path:"/operator/agentmanager/settings",permissions:"CAN_VIEW_AGENT_MANAGER_SETTINGS"},
  { name: <Translate id="operator_menu.setting"/>, icon: <Settings />,path:"/operator/settings",permissions:"CAN_VIEW_SETTINGS"},
  { name: <Translate id="operator_menu.logout"/>, icon: <ExitToApp />, path: "/operator/logout" ,permissions:"INITIAL"},
];

const menuAgentManager=[
  { name: "Home", icon: <Home />, path: "/operator/agentmanager/home",permissions:"CAN_VIEW_AGENT_MANAGER_HOME"},
  { name: "Agent", icon: <People />, path: "/operator/agentmanager/agent",permissions:"CAN_VIEW_AGENT_MANAGER_AGENTS" },
  { name: "Transactions", icon: <SyncAlt />, path: "/operator/agentmanager/transaction",permissions:"CAN_VIEW_AGENT_MANAGER_TRANSACTIONS" },

];

const drawerWidth = 250;

const useStyles = makeStyles((theme) => ({
  root: {},
  title: {
    flexGrow: 1,
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    border: 0,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  btn: {
    textTransform: "capitalize",
  },
  paper: {
    padding: 15,
  },
  icon: {
    height: 45,
    marginRight: 10,
    display: "block",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    borderRadius: 10,
  },
  operatorLogo: {
    height: 100,
  },
}));

function OperatorHome(props) {

  const [nxOp,setnxOp]=useState({});

  const { window } = props;
  const classes = useStyles();
  const Theme = useTheme();
  const history = useHistory();

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const menuOpen = Boolean(anchorEl);
  const [logoutOpen, setLogoutOpen] = useState(false);

  const [openMenu, setOpenMenu] = useState("none");

  const [operatorMenus, setOperatorMenus] = useState([]);


  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

 


  const drawer = (
    <div>
      <div className={classes.toolbar} />

      <Divider />
      <List>

      {nxOp?.user_type=="AGENT_MANAGER"&&menuAgentManager.map((menu, index) => (<Permissions permissions={menu.permissions}>
            <div>
              {" "}
              <ListItem
                button
                key={menu.name}
                onClick={() => {
                  if (menu.submenu) {
                    if (openMenu == index) {
                      setOpenMenu("none");
                    } else {
                      setOpenMenu(index);
                    }
                  } else {
                    history.push(menu.path);
                  }
                  setMobileOpen(false);
                }}
                selected={menu.path == history.location.pathname}
              >
                <ListItemIcon>{menu.icon}</ListItemIcon>
                <ListItemText primary={menu.name} />
                {menu.submenu ? (
                  openMenu == index ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )
                ) : (
                  <div />
                )}
              </ListItem>
              {menu.submenu && (
                <Collapse in={openMenu == index} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {menu.submenu.map((sub, i) => (
                      <ListItem
                        button
                        className={classes.nested}
                        onClick={() => {
                          history.push(sub.path);
                          setMobileOpen(false);
                        }}
                        selected={sub.path == history.location.pathname}
                      >
                        <ListItemIcon>
                          <ArrowRight />
                        </ListItemIcon>
                        <ListItemText primary={sub.name} />
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              )}
            </div>
          </Permissions>)
)}
        {operatorMenus.filter((m)=>m.name!==undefined).map((menu, index) => (<Permissions permissions={menu.permissions}>
            <div>
              {" "}
              <ListItem
                button
                key={menu.name}
                onClick={() => {
                  if (menu.submenu) {
                    if (openMenu == index) {
                      setOpenMenu("none");
                    } else {
                      setOpenMenu(index);
                    }
                  } else {
                    history.push(menu.path);
                  }
                  setMobileOpen(false);
                }}
                selected={menu.path == history.location.pathname}
              >
                <ListItemIcon>{menu.icon}</ListItemIcon>
                <ListItemText primary={menu.name} />
                {menu.submenu ? (
                  openMenu == index ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )
                ) : (
                  <div />
                )}
              </ListItem>
              {menu.submenu && (
                <Collapse in={openMenu == index} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {menu.submenu.map((sub, i) => (
                      <ListItem
                        button
                        className={classes.nested}
                        onClick={() => {
                          history.push(sub.path);
                          setMobileOpen(false);
                        }}
                        selected={sub.path == history.location.pathname}
                      >
                        <ListItemIcon>
                          <ArrowRight />
                        </ListItemIcon>
                        <ListItemText primary={sub.name} />
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              )}
            </div>
          </Permissions>)
)}
      </List>

      
      <Divider />
      <List>
        {menus2.map((menu, index) => (
<Permissions permissions={menu.permissions}>
          <ListItem
            button
            key={menu.name}
            onClick={() => {
              if (menu.path === "/operator/logout") {
                setLogoutOpen(true);
              } else {
                history.push(menu.path);
              }
            }}
          >
            <ListItemIcon>{menu.icon}</ListItemIcon>
            <ListItemText primary={menu.name} />
          </ListItem>
    </Permissions>
        ))}
      </List>
    </div>
  );

  


  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const container =
    window !== undefined ? () => window().document.body : undefined;
  const matches = useMediaQuery(Theme.breakpoints.up("sm"));
  

  useEffect(() => {
    var data = {};
    const data1 = localStorage.getItem("nx_op");
    console.log("nx_op");
    console.log(data1);
    if (data1 != null) {
      data = JSON.parse(data1);
      setnxOp(data);
      load_details(data.token);
      if (data.token == null) {
        history.replace("/");
        return;
      }
      userMustChangePassword(JSON.parse(data1));
    } else {
     
      history.replace("/", { expired: true });
    }
    var menus=getMenus();
    setOperatorMenus(menus)
  }, []);

  const [loadDetails,setLoadDetails]=useState(true);

  const [details,setDetails]=useState({});

  const load_details=(token)=>{
    setLoadDetails(true);

    console.log("load details......");

    axios.defaults.baseURL = new AdminService().BASE_URL;
    const detailsInstance = axios.create(new AdminService().setHeaders(token));
    detailsInstance.get("/api/v1/organization/"+new UserInfo().ORG_ID)
    .then((res)=>{

      setLoadDetails(false);
      setDetails(res.data.data);
      var data=JSON.stringify(res.data.data);
      localStorage.setItem("operatorAgent",data);

      console.log("result");
      console.log(res.data);


    })
    .catch(err=>{

    });

  }


  const userMustChangePassword=(userData)=>{
    if(userData.user_must_change_password===true){
      enqueueSnackbar("Please change your password", { 
        variant: 'info',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });
      history.push("/operator/settings");
    }

  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Dialog
        open={logoutOpen}
        onClose={() => setLogoutOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Logout"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to logout of your account?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLogoutOpen(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              localStorage.removeItem("nx_op");
              localStorage.removeItem("profile");
              localStorage.removeItem("nx_ag");
              history.replace("/");
            }}
            color="primary"
            autoFocus
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
      <AppBar position="fixed" elevation={0} className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>

          {loadDetails==false&&details['logo_file_byte']!=null&&<img src={"data:image/png;base64,"+details['logo_file_byte']} alt="icon" className={classes.icon} />
        }
        
          
          {loadDetails==true&&<img src={OperatorLogo} alt="icon" className={classes.icon} />}
          <Box className={classes.title}>
            <Typography variant={matches ? "h5" : "h6"} noWrap>
            {new UserInfo().OPERATOR_NAME}
            </Typography>
          </Box>

          <Box ml={matches && 2}>
            <IconButton color="inherit">
              {/* <Badge
                badgeContent={1}
                showZero={false}
                variant="standard"
                color="secondary"
              > */}
                <Mail />
              {/* </Badge> */}
            </IconButton>
          </Box>

          <Box ml={matches && 2}>
            <IconButton color="inherit">
              {/* <Badge
                badgeContent={1}
                showZero={false}
                variant="standard"
                color="secondary"
              > */}
                <Notifications />
              {/* </Badge> */}
            </IconButton>
          </Box>

          <div>
            <Button
              onClick={handleMenu}
              color="inherit"
              variant={matches && "outlined"}
              size="small"
              className={classes.btn}
          endIcon={<Avatar>{new UserInfo().SHORT}</Avatar>}
              startIcon={matches && <img src={SafariLogo} height={35} />}
            ></Button>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              open={menuOpen}
              onClose={handleClose}
            >
             <Permissions permissions="CAN_VIEW_ORG_USER"> <MenuItem onClick={()=>{
               history.push("/operator/users");
              }}>Users</MenuItem>
              </Permissions>
              <MenuItem onClick={()=>{
                history.push("/operator/settings");
              }}>Settings</MenuItem>
              <MenuItem
                onClick={() => {
                  setLogoutOpen(true);
                  handleClose();
                }}
              >
                Logout
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="Agent menus">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={"bottom"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Switch>
          {routes.map((route, i) => (
            
            <Route
              key={i}
              exact={route.exact}
              path={route.path}
              component={route.main}
            />
          ))}
        </Switch>
      </main>
    </div>
  );
}

export default withLocalize(OperatorHome);
